import { SendLockIcon } from './SendLockIcon';

/**
 * author: Michael Richins
 * id 343A4B08-D77B-453B-A8A7-AF40D1A98DD2
 * name send-lock
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/send-lock.svg
 * tags
 * - Lock 
 */
export const SendSecureIcon = SendLockIcon;
export default SendSecureIcon